<script lang="ts">
	import Chip, { Text } from '@smui/chips/styled';
	import CustomText from '../Text.svelte';
	export let interestList = [];
	export let operator: string;
</script>

<div class="wrap">
	{#each interestList as interest}
		<Chip chip="adformOkChip" class="interest-list-chip">
			<Text class="interest-list-chiptext">{interest.replace('_', ' ')}</Text>
		</Chip>
		{#if operator !== null && interestList.length - 1 !== interestList.indexOf(interest)}
			<div>
				<CustomText>{operator}</CustomText>
			</div>
		{/if}
	{/each}
</div>

<style>
	.wrap {
		display: flex;
		flex-wrap: wrap;
		align-items: baseline;
		padding: 3px 0 3px 0;
	}

	.wrap > div {
		margin-right: 6px;
	}
</style>
